import { Redirect, router } from 'expo-router';
import * as React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H2Emphasized,
    Icon,
    ScreenContainer,
    SplitIcon,
    View,
    YStack,
} from 'smoothie';

import useShouldSeeIncomeSplit from '../../hooks/income-split/useShouldSeeIncomeSplit';
import { BankDisclosureShortFootnote } from '../Disclosures';

interface RoutingConfirmationProps {
    isEdit: boolean;
}
const RoutingConfirmation = ({ isEdit }: RoutingConfirmationProps) => {
    const shouldSeeIncomeSplit = useShouldSeeIncomeSplit();

    if (shouldSeeIncomeSplit) {
        return <Redirect href="/home/banking" />;
    }

    return (
        <ScreenContainer
            hasCloseButton
            onClose={() => {
                router.navigate('/home/banking');
            }}
            onFallbackRoute="/home/banking"
        >
            <YStack gap={24} justifyContent="space-between">
                <YStack
                    gap={24}
                    justifyContent="center"
                    alignItems="center"
                    marginTop={56}
                >
                    <View
                        width={72}
                        height={72}
                        borderRadius={36}
                        backgroundColor="$green1100"
                        alignItems="center"
                        justifyContent="center"
                        transform={[{ rotate: '90deg' }]}
                    >
                        <Icon icon={SplitIcon} size={32} color="$white" />
                    </View>
                    <YStack gap={16}>
                        {isEdit ? (
                            <H2Emphasized textAlign="center">
                                Your paycheck split has been updated!
                            </H2Emphasized>
                        ) : (
                            <H2Emphasized textAlign="center">
                                Your paycheck split is now set up!
                            </H2Emphasized>
                        )}
                        <BodyMediumRegular textAlign="center" color="$gray1000">
                            You will receive an email confirmation each time
                            your paycheck is detected and these rules are
                            executed.
                        </BodyMediumRegular>
                    </YStack>
                </YStack>

                <YStack gap={12}>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Done"
                        onPress={() => {
                            router.navigate('/home/banking');
                        }}
                    />
                    <BankDisclosureShortFootnote />
                </YStack>
            </YStack>
        </ScreenContainer>
    );
};

export default RoutingConfirmation;
